import { render } from "./delivery-from.vue?vue&type=template&id=b4a28bd8&scoped=true"
import script from "./delivery-from.vue?vue&type=script&lang=js"
export * from "./delivery-from.vue?vue&type=script&lang=js"

import "./delivery-from.vue?vue&type=style&index=0&id=b4a28bd8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a28bd8"]])

export default __exports__